import React from "react";
import { useTranslation } from "react-i18next";
const FormInputBillingAddress = ({
    name,
    placeholder,
    value,
    onChange,
    disabled,
    label,
    isInvalid,
    invalidMessage
}) => {
    const {t} = useTranslation();
    return (
        <>
            <div className="form-floating address-input-container">
                <input
                    type="text"
                    className={`form-control contact-form ${isInvalid && "is-invalid"} address-input d-md-block d-none`}
                    id="streetAddress"
                    // placeholder={t("NewCheckout.PersonalInformation.StreetAddress.Placeholder")}
                    placeholder={placeholder}
                    name={name}
                    value={value}
                    onChange={(e) => onChange(e)}
                    disabled={disabled}
                    style={{
                        color: value ? "#282828" : "",
                        fontWeight: value ? "bold" : "",
                    }}
                />
                <textarea
                    className={`form-control contact-form ${isInvalid && "is-invalid"} address-input d-md-none d-sm-block`}
                    id="streetAddress"
                    // placeholder={t("NewCheckout.PersonalInformation.StreetAddress.Placeholder")}
                    placeholder={placeholder}
                    name={name}
                    value={value}
                    disabled={disabled}
                    onChange={(e) => onChange(e)}
                    style={{
                        color: value ? "#282828" : "",
                        fontWeight: value ? "bold" : "",
                    }}
                />
                <label htmlFor="streetAddress">
                    {label}
                </label>
                {isInvalid && (
                    <p className="text-danger">
                        {/* {t("Please.enter.your.address")} */}
                        {invalidMessage}
                    </p>
                )}
            </div>
        </>
    );
};

export default FormInputBillingAddress;
